import { englishValidationMessages } from './messages';
import { noHtmlPatternValidator } from './rawValidators';
import { getRequiredValidator } from './required';
export const makeRichTextValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ function getRichTextValidator(valueName) {
        let required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const requiredValidator = getRequiredValidator(required);
        return (value)=>{
            const requiredError = requiredValidator(value);
            if (requiredError !== true) {
                return requiredError;
            }
            if (!noHtmlPatternValidator(value)) {
                return messages.htmlCharacters({
                    field: valueName
                });
            }
            return true;
        };
    }
    /** For react-hook-form library. */ const richTextValidation = function richTextValidation(valueName) {
        let { required } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                richText: getRichTextValidator(valueName, required)
            },
            dataAttr: {
                'data-validation': 'rich-text'
            }
        };
    };
    return {
        getRichTextValidator,
        richTextValidation
    };
};
export const { getRichTextValidator, richTextValidation } = makeRichTextValidators(englishValidationMessages);
